import React, { useContext } from "react";
import "./BusinessCover.scss";
import call from "../../assets/images/Icon ionic-ios-call.png";
import comment from "../../assets/images/Icon awesome-comment.png";
import instagram from "../../assets/images/Icon awesome-instagram.png";
import BusinessContext from "context/BusinessContext";
import background from "../../assets/images/4058271.jpg";
import logo from "../../assets/images/Screenshot (426).svg";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { connection } from "utils/apiConnection.ts";
import more from "../../assets/images/icons8-menu-vertical-30.png";

const BusinessCover = ({ business }) => {
  let params = useParams();
  const auth = useContext(WithAuthentication);
  console.log(auth);
  let customeraccount = false;
  const { logbeforejoin, setComments, setContact, setbpid, setLogbeforejoin } =
    useContext(BusinessContext);
  const contact = {
    name: business.title,
    tell: business.tell,
    mobile: business.mobile,
    socialMedia: JSON.parse(business.other_params).socialMedia,
  };
  setbpid(business.id);
  let insta = contact.socialMedia.find((value) => value.selectField == 1);
  const bashgah = auth.userInfo.ccShopIds.find(
    (value) => value.id == business.id
  );
  if (bashgah) customeraccount = true;
  else customeraccount = false;
  function theAlert() {
    console.log(auth.userInfo);
    if (auth.userInfo.id < 1) return;
    Swal.fire({
      title: "عضویت در باشگاه مشتریان",
      text: `آیا میخواهید در فروشگاه ${business.title} عضو شوید؟`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let keyvalues = {
          uid: auth.userInfo.id,
          bpid: business.id,
        };
        console.log(keyvalues);
        let { status } = await connection("joinclub", keyvalues);
        if (status == 1) {
          Swal.fire("موفق", "با موفقیت عضو باشگاه مشتریان شدید.", "success");

          auth.setUserInfo((info) => ({
            ...info,
            ccShopIds: [
              ...info.ccShopIds,
              { id: business.id, shopSuffix: params.shop_suffix },
            ],
          }));
        } else if (status == 0) {
          Swal.fire(
            "ناموفق",
            "مشکلی در عضویت در باشگاه مشتریان به وجود آمده است",
            "error"
          );
        } else if (status == -1) {
          Swal.fire(
            "خطا!",
            "شما عضو باشگاه مشتریان این فروشگاه هستید",
            "warning"
          );
        }
      }
    });
    setLogbeforejoin(false);
  }
  return (
    <>
      {logbeforejoin ? theAlert() : ""}
      {business ? (
        <div className="col-12 mainCover">
          <img
            src={
              business.coverAddress != "" ? business.coverAddress : background
            }
            alt="cover"
            className="col-12"
            id="cover"
          />
          <div className="onImage overlay"></div>
          <div className="onImage center row">
            <div className="rightSide col-3 col-sm-2">
              <div className="contact">
                <button
                  href="#contact"
                  data-bs-toggle="modal"
                  data-bs-target="#ModalContact"
                  onClick={(e) => setContact(contact)}
                >
                  <div className="round" style={{ backgroundColor: "#56A689" }}>
                    <img src={call} alt="call" />
                  </div>
                  اطلاعات تماس
                </button>
              </div>
              <div className="contact">
                <button
                  href="#comments"
                  data-bs-toggle="modal"
                  data-bs-target="#CustomerMessages"
                  onClick={(e) => setComments(business.customerMessages)}
                >
                  <div className="round" style={{ backgroundColor: "#586BA6" }}>
                    <img src={comment} alt="comment" />
                  </div>
                  نظرات مشتریان
                </button>
              </div>
            </div>
            <div className="info col-8 col-sm-8">
              {auth.isLogged ? (
                <div
                  className="dropdown Mdrop d-md-dropstart d-sm-none"
                  style={{ float: "left", marginTop: "-60px" }}
                >
                  <button
                    className="btn btn-secondary dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img src={more} alt="more" />
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <Link className="dropdown-item" to={"/user-profile"}>
                        پروفایل کاربر
                      </Link>
                    </li>
                    {auth.userInfo.shopIds.map((value) => {
                      return (
                        <li>
                          <Link
                            className="dropdown-item"
                            to={`/profile/${value.shopSuffix}`}
                          >
                            {value.title}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : (
                ""
              )}

              <div className="round businessImage">
                <img
                  src={business.logoAddress != "" ? business.logoAddress : logo}
                  alt="businessImage"
                />
              </div>
              <br />
              {!auth.isLogged ? (
                <>
                  <button
                    className="btn btn-primary btn-join"
                    data-bs-toggle="modal"
                    data-bs-target="#ModalNumber"
                  >
                    ورود به باشگاه مشتریان
                  </button>
                </>
              ) : auth.isLogged && customeraccount ? (
                <Link className="btn btn-primary btn-join" to={"/user-profile"}>
                  پنل کاربری
                </Link>
              ) : auth.isLogged && !customeraccount ? (
                <button
                  className="btn btn-primary btn-join"
                  onClick={(e) => theAlert()}
                >
                  ورود به باشگاه مشتریان
                </button>
              ) : (
                ""
              )}
              <br />
              {business.title != "" ? (
                <div className="name">{business.title}</div>
              ) : (
                ""
              )}
              {business.address_text != "" ? (
                <div className="address">آدرس : {business.address_text}</div>
              ) : (
                ""
              )}
              {insta ? (
                <div className="address">
                  {insta.nameField}
                  {" : "}
                  <img src={instagram} alt="instagram" />
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="d-none d-sm-block col-1">
              {auth.isLogged ? (
                <div
                  className="dropdown Mdrop d-md-dropstart"
                  style={{ float: "left" }}
                >
                  <button
                    className="btn btn-secondary dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img src={more} alt="more" />
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <Link className="dropdown-item" to={"/user-profile"}>
                        پروفایل کاربر
                      </Link>
                    </li>
                    {auth.userInfo.shopIds.map((value) => {
                      return (
                        <li>
                          <Link
                            className="dropdown-item"
                            to={`/profile/${value.shopSuffix}`}
                          >
                            {value.title}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default BusinessCover;
